import { render, staticRenderFns } from "./member_transBg.vue?vue&type=template&id=33d24c50&scoped=true&"
import script from "./member_transBg.vue?vue&type=script&lang=js&"
export * from "./member_transBg.vue?vue&type=script&lang=js&"
import style0 from "./member_transBg.vue?vue&type=style&index=0&id=33d24c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d24c50",
  null
  
)

export default component.exports